module.exports = "/packs/about-coaching-section-image-c1c17a66026717ce11e8f143295d92a5.png";